import React from 'react';
import SimpleImageSlider from "react-simple-image-slider";


export default function BarAndKitchen() {
    
      const images = [
        { url: "/assets/images/bar.JPG" },
        { url: "/assets/images/kitchen.jpeg" },
      ];
    //   570 × 378 px
      const Slideshow = () => {
        return (
            <div>
            <SimpleImageSlider
              width={570}
              height={378}
              images={images}
              showBullets={true}
              showNavs={false}
              autoPlay={true}
              autoPlayDelay={3.0}
            />
          </div>
        )
    }

  return (
    <div>
        {Slideshow() }
    </div>
  )
}
